import types from './types'
import { cloneDeep } from 'lodash'

export default {
  [types.getters.currentUser]: state => cloneDeep(state.user),
  [types.getters.signedIn]: state => !!cloneDeep(state.user),
  [types.getters.localeCode]: state => {
    switch (state.locale) {
      case 'nl': return 'nl-be'
      case 'fr': return 'fr-be'
      default: return 'nl-be'
    }
  }
}
